import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { FormikSelect } from '../../../../components/Formik';

import type { ComputeOrderValues, Product } from '@/types/productTypes';

interface ProductSelectProps {
  filteredProducts: Product[];
}

const ProductSelect = ({ filteredProducts }: ProductSelectProps): React.JSX.Element => {
  const intl = useIntl();
  const {
    values: { projectId, osProjectName },
    setValues,
  } = useFormikContext<ComputeOrderValues>();

  const products = projectId
    ? filteredProducts.filter(product => product.projectId === projectId)
    : [];

  useEffect(() => {
    if (projectId && products.length === 0) {
      setValues(prev => ({
        ...prev,
        buttonHelperText: intl.formatMessage({ id: 'noProductsForProject' }),
      }));
    }
  }, [projectId, products.length, setValues, intl]);

  return (
    <FormikSelect
      name='productId'
      label={intl.formatMessage({ id: 'product' })}
      disabled={!projectId}
      menuItems={products.map(product => ({
        value: product._id,
        label: product.name,
      }))}
      onChange={(selected: {
        id?: string | undefined;
        value?: string | undefined;
        label?: string;
      }): void => {
        const selectedProduct = products.find(p => p._id === selected.value);
        setValues({
          osProjectName,
          projectId,
          productId: selected.value ?? '',
          juiceGroup: selectedProduct ? selectedProduct.details.juiceGroup : '',
          cloudName: '',
          cpuCores: '',
          ram: '',
          diskQuota: '',
          floatingIps: '',
          internetConnectivity: false,
          DTHConnectivity: false,
          DTHRedRouterConnectivity: false,
          unusedQuota: {
            compute: {
              cores: 0,
              ram: 0,
            },
            volume: {
              gigabytes: 0,
            },
            network: {
              floatingIps: 0,
            },
          },
          externalNetworks: [],
          buttonHelperText: '',
        });
      }}
    />
  );
};

export default ProductSelect;
